// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

//added sidechain
// import Sidechain from '@nprapps/sidechain';
// const guest = Sidechain.registerGuest({ sentinel: 'st' });
//
// guest.sendMessage({
//   type: 'analytics',
//   eventCategory: 'interaction',
//   eventAction: 'click',
//   eventLabel: 'etc'
// })
//end sidechain

const $ = require('jquery');
require('waypoints/lib/noframework.waypoints.min');

const worldData = require('../../data/World.sheet.json');
const invadeData = require('../../data/Invade.sheet.json');
const fondaData = require('../../data/Fonda.sheet.json');

// console.log(refundFreezeData);

var windowWidth = $('.scroll-blocks').width();
var extra = (windowWidth > 600) ? 250 : 550;
var triggerFadeIn = windowWidth > 500 ? '60%' : '120%';

function makeWayPoints() {
  $('.scroll-blocks .block').each((index, element) => {

          $(element).ready(function() {
            var player = this;

            new Waypoint({
                element: element,
                enabled: true,
                handler: function(direction) {
                  var classList = $(element).attr("class").split(' ')[1];
                  if(direction === "down") {
                    $(`.svg svg #${classList}`).find( "rect" ).addClass("show");
                    $(`.svg svg #${classList}`).find( "foreignObject" ).addClass("show");
                  }
                  else if (direction === "up") {
                  }
                },
                offset: triggerFadeIn
            });

            new Waypoint({
                element: element,
                enabled: true,
                handler: function(direction) {
                  var classList = $(element).attr("class").split(' ')[1];
                  if(direction === "down") {
                  }
                  else if (direction === "up") {
                    $(`.svg svg #${classList}`).find( "rect" ).removeClass("show");
                    $(`.svg svg #${classList}`).find( "foreignObject" ).removeClass("show");
                  }
                },
                offset: '95%'
            });

          });

    });
};

$( document ).ready(function() {

    var tearsWidth = $('.secondSvg img').width();
    makeWayPoints();

    $( '.thirdSvg svg' ).ready(function() {
    $( ".thirdSvg svg rect" ).click(function() {
      var id = $(this).data("id");
      $( ".thirdSvg svg rect" ).removeClass('show');

      worldData.forEach(element => {
        if (element.svg === id) {
          //$(this).addClass('show');
          $(`[data-id='${id}']`).addClass('show');

          var labelRefund = element.final_category;
          console.log(labelRefund);
          var noSpaceKeyRefund = labelRefund.replace(/\s/g, '');
          noSpaceKeyRefund = noSpaceKeyRefund.replace(/[^a-zA-Z ]/g, "");

          $('#worldPopup').removeClass();
          $('#worldPopup #world-label').removeClass();

          var ratioRefund = tearsWidth / 365.8;
          var topRefund = $(this).attr('y');
          var leftRefund = $(this).attr('x') > 240 ? (220 * ratioRefund) : ($(this).attr('x') * ratioRefund);
          //var leftRefund = $(this).attr('x') * ratioRefund;
          leftRefund = tearsWidth > 500 ? leftRefund : 0;

          var heightRefund = $(this).attr('height');

          var offsetTop_Refund = ((topRefund * ratioRefund) + ((parseFloat(heightRefund)) * ratioRefund));

          $('#worldPopup #world-label').addClass(`${noSpaceKeyRefund}`).empty().append(element.final_category);
          $('#worldPopup .comment').empty().append(element.caption_popup);
          $('#worldPopup').css("top", `${offsetTop_Refund}px`);
          $('#worldPopup').css("left", `${leftRefund}px`);
          $('#worldPopup').addClass('show');

        } else {}
      });
    });
  });

$( '.secondSvg img' ).ready(function() {
    $( ".secondSvg svg rect" ).click(function(e) {
      var id = $(this).attr('id');
      $( ".secondSvg svg rect" ).removeClass('show');
      fondaData.forEach(element => {
        if (element.svg === id) {
          $(this).addClass('show');

          var label = element.final_category
          var noSpaceKey = label.replace(/\s/g, '');
          noSpaceKey = noSpaceKey.replace(/[^a-zA-Z ]/g, "");

          $('#fondaPopup').removeClass();
          $('#fondaPopup #fonda-label').removeClass();

          var gCon = $(this).closest( "g" );
          var object = gCon[0].getBoundingClientRect();

          var chosenRect = this.getBoundingClientRect();

          var top = $(this).attr('y');
          var left = $(this).attr('x');
          left = tearsWidth > 500 ? left : 0;
          var height = $(this).attr('height');
          var ratio = tearsWidth / 480;

          var offsetTop = (top * ratio) + ((parseFloat(height) + 1) * ratio);

          // var left = e.clientX > (tearsWidth/2) ? (tearsWidth/2) : e.clientX;

          $('#fondaPopup #fonda-label').addClass(`${noSpaceKey}`).empty().append(element.final_category);
          $('#fondaPopup .comment').empty().append(element.caption_popup);
          $('#fondaPopup').css("top", `${offsetTop}px`);
          $('#fondaPopup').css("left", `${left * ratio}px`);
          $('#fondaPopup').addClass('show');

        } else {}
      });
    });
});

$( '.fourthSvg img' ).ready(function() {
      $( ".fourthSvg svg rect" ).click(function(e) {
        var id = $(this).attr('id');
        $( ".fourthSvg svg rect" ).removeClass('show');
        invadeData.forEach(element => {
          if (element.svg === id) {
            $(this).addClass('show');

            var label = element.final_category;
            var noSpaceKey = label.replace(/\s/g, '');
            noSpaceKey = noSpaceKey.replace(/[^a-zA-Z ]/g, "");

            $('#invadePopup').removeClass();
            $('#invadePopup #invade-label').removeClass();
            var chosenRect = this.getBoundingClientRect();

            var top_top = $(this).attr('y');
            //var left_top = ($(this).attr('x') > 200) ? ($(this).attr('x') + 100) : 50;
            var left_top = $(this).attr('x');
            left_top = tearsWidth > 500 ? left_top : 0;
            var height_top = $(this).attr('height');
            var top_ratio = tearsWidth / 480;

            var offsetTop_Top = (top_top * top_ratio) + (parseFloat(height_top) * top_ratio);

            $('#invadePopup #invade-label').addClass(`${noSpaceKey}`).empty().append(element.final_category);
            $('#invadePopup .comment').empty().append(element.caption_popup);
            $('#invadePopup').css("top", `${offsetTop_Top}px`);
            $('#invadePopup').css("left", `${left_top * top_ratio}px`);
            $('#invadePopup').addClass('show');

          } else {}
        });
      });

      if (window.innerWidth > 451) {
        setTimeout(function() {
            var firstCall = $( '#allStories' ).find('.story[data-id="fonda"]').height() + extra;
            $('#allStories').height(firstCall + 'px');
            console.log($( '#allStories' ).find('.story[data-id="fonda"]').height());
          }, 700);
        } else {
          setTimeout(function() {
            var firstCall = $( '#allStories' ).find('.story[data-id="fonda"]').height()-300 + extra;
            $('#allStories').height(firstCall + 'px');
            console.log($( '#allStories' ).find('.story[data-id="fonda"]').height());
          }, 700);
        }
  });

    $( "#worldPopup .close" ).click(function() {
      $('#worldPopup').removeClass('show');
      $( ".thirdSvg svg rect" ).removeClass('show');
    });

    $( "#invadePopup .close" ).click(function() {
      $('#invadePopup').removeClass('show');
      $( ".fourthSvg svg rect" ).removeClass('show');
    });

    $( "#fondaPopup .close" ).click(function() {
      $('#fondaPopup').removeClass('show');
      $( ".secondSvg svg rect" ).removeClass('show');
    });

    $( "button.redact" ).click(function() {
      $( "button.redact span" ).toggleClass( "show" );

      $(this).closest( ".example" ).find('.example_image').toggleClass('show');
    });


    $( ".buttonCon button" ).click(function() {
      $( ".buttonCon button" ).removeClass('show');
      $( ".story" ).removeClass('show');
      $( this ).addClass('show');
      var findID = $( this).data('id');
      $( '#allStories' ).find(`.story[data-id='${findID}']`).addClass('show');
      var storyHeight = $( '#allStories' ).find(`.story[data-id='${findID}']`).height();
      var setHeight = (findID === "world") ? (storyHeight + extra) : storyHeight;
      $('#allStories').height(setHeight + "px");
    });
});
